// extracted by mini-css-extract-plugin
export default {"landingContainer":"Landing_landingContainer__xK0+m","bannerContent":"Landing_bannerContent__KY-p8","title":"Landing_title__CKSho"};